import { Site } from '@debbie/common/dist/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import PDF from '../components/PDF.js';
import { FILEBASE } from '../config.js';
import THEME from '../theme.js';
import Badge from './Badge.js';
import { PreviewWrapper } from './PreviewWrapper.js';
export const LetterPreview = (props) => {
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    return (React.createElement(PreviewWrapper, { selected: props.selected, onClick: props.onClick },
        React.createElement("h1", null,
            "Letter",
            ' ',
            site === Site.Caseworker && props.interaction.aiGenerated && (React.createElement(Badge, { theme: THEME.COLOR_ACCENT, style: { marginLeft: '0.3em' } }, lang.interactions.aiGenerated)),
            props.interaction.paused && (React.createElement(Badge, { theme: THEME.WARNING, style: { marginLeft: '0.3em' } }, lang.cases.casePaused)),
            React.createElement("small", { style: {
                    float: 'right',
                } }, moment(props.interaction.createdAt).format(THEME.DATE_FORMAT_LONG)))));
};
export const Letter = (props) => (React.createElement("div", null,
    React.createElement(PDF, { link: `${FILEBASE}/${props.interaction.details.pdf}/letter.pdf`, style: {
            display: 'block',
            width: 'calc(100% + 40px)',
            height: 'calc(100vh - 56px)',
            margin: '-20px',
        } })));
export default Letter;
//# sourceMappingURL=Letter.js.map